"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.renderGlobally = exports.bmBadgeStyle = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@blue/element");

var _utils = require("./utils");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t.bm-badge {\n\t\tdisplay: inline-flex;\n\t\tcontain: content;\n\t\tfont-size: 11px;\n\t\tpadding: 0 0.636em;\n\t\tfont-weight: 300;\n\t\ttext-align: center;\n\t\twhite-space: nowrap;\n\t\tvertical-align: baseline;\n\t\tline-height: 1.5em;\n\t\tfont-family: Arial, 'Helvetica Neue', sans-serif;\n\t\tletter-spacing: 0.05em;\n\t\ttext-transform: uppercase;\n\t\tborder-radius: 0.273em;\n\t\tposition: relative;\n\t\tcolor: #606169;\n\t\tcolor: var(--primary, #606169);\n\t\tbackground-color: #fff;\n\t}\n\n\t.bm-badge.success {\n\t\tcolor: #fff;\n\t\tbackground-color: #387c2b;\n\t\tbackground-color: var(--success, #387c2b);\n\t}\n\n\t.bm-badge.danger {\n\t\tcolor: #fff;\n\t\tbackground-color: #dc0a0a;\n\t\tbackground-color: var(--danger, #dc0a0a);\n\t}\n\n\t.bm-badge.warning {\n\t\tcolor: #212529;\n\t\tbackground-color: #ffb400;\n\t\tbackground-color: var(--warning, #ffb400);\n\t}\n\n\t.bm-badge.info {\n\t\tcolor: #fff;\n\t\tbackground-color: #0072a8;\n\t\tbackground-color: var(--info, #0072a8);\n\t}\n\n\t.bm-badge.primary {\n\t\tcolor: #fff;\n\t\tbackground-color: #606169;\n\t\tbackground-color: var(--primary, #606169);\n\t}\n\n\t.bm-badge[href] {\n\t\ttext-decoration: none;\n\t}\n\n\t.bm-badge[href].success:hover {\n\t\tbackground-color: #27561e;\n\t}\n\n\t.bm-badge[href].danger:hover {\n\t\tbackground-color: #ab0808;\n\t}\n\n\t.bm-badge[href].warning:hover {\n\t\tbackground-color: #cc9000;\n\t}\n\n\t.bm-badge[href].info:hover {\n\t\tbackground-color: #004f75;\n\t}\n\n\t.bm-badge[href].primary:hover {\n\t\tbackground-color: #48484e;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var bmBadgeStyle = (0, _element.css)(_templateObject());
exports.bmBadgeStyle = bmBadgeStyle;

var renderGlobally = function renderGlobally() {
  return (0, _utils.renderStyleCssGlobally)(bmBadgeStyle, 'bmBadgeStyle');
};

exports.renderGlobally = renderGlobally;
